import React, { useState } from "react";

const CATEGORIES = [
  { key: "incident_near_miss", label: "Incident / Near Miss" },
  { key: "environmental", label: "Environmental Concerns" },
  { key: "equipment_damage", label: "Equipment Damage" },
  { key: "management_of_change", label: "Management of Change" },
  { key: "others", label: "Others" },
];

const HsseqTable = ({ hsseq, dprId, onSave }) => {
  const getEntry = (category) =>
    hsseq.find((h) => h.category === category) || {
      dprId,
      category,
      details: "N/A",
    };

  const [rows, setRows] = useState(() =>
    CATEGORIES.map((cat) => getEntry(cat.key))
  );
  const [editingIdx, setEditingIdx] = useState(null);
  const [draftValue, setDraftValue] = useState("");

  const handleStartEdit = (idx, value) => {
    setEditingIdx(idx);
    setDraftValue(value);
  };

  const handleCommit = () => {
    if (editingIdx === null) return;
    const updated = rows.map((row, i) =>
      i === editingIdx ? { ...row, details: draftValue } : row
    );
    setRows(updated);
    setEditingIdx(null);
    setDraftValue("");
    onSave(updated);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleCommit();
    if (e.key === "Escape") {
      setEditingIdx(null);
      setDraftValue("");
    }
  };

  return (
    <section>
      <h3 className="section-eyebrow mb-3">HSSEQ</h3>
      <table className="table-hairline">
        <thead>
          <tr>
            <th className="w-1/3">Category</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={row.category}>
              <td className="font-medium text-zinc-700">
                {CATEGORIES[idx].label}
              </td>
              <td>
                {editingIdx === idx ? (
                  <input
                    type="text"
                    value={draftValue}
                    onChange={(e) => setDraftValue(e.target.value)}
                    onBlur={handleCommit}
                    onKeyDown={handleKeyDown}
                    autoFocus
                    onFocus={(e) => e.target.select()}
                    className="w-full rounded border border-navy-600 bg-white px-1.5 py-0.5 text-sm focus:outline-none focus:ring-2 focus:ring-navy-600/20"
                  />
                ) : (
                  <div
                    onClick={() => handleStartEdit(idx, row.details)}
                    className="min-h-[1.5em] cursor-pointer rounded px-1 -mx-1 hover:bg-navy-50/60"
                  >
                    {row.details === "N/A" || !row.details ? (
                      <span className="text-zinc-400">N/A</span>
                    ) : (
                      row.details
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default HsseqTable;
